import { START_PAGE } from "../../utils/Constant";
import { GET_ALL_ROLE_DATA } from "./ActionTypes";

export const getAllRoleData = (payload, currentPage = START_PAGE) => ({
    type: GET_ALL_ROLE_DATA,
    payload,
    currentPage,
});
